export const ctaTriggerAndNavigate = (cvUrl) => {
  window.location.href = cvUrl;
}
